import axios from '@/lib/axios';
import type { ConfiguracoesCliente } from '@/lib/config-geral';

/**
 * Service de configurações — endpoints /api/configuracoes/*.
 * Cada função retorna o payload já desempacotado (response.data).
 */

export async function getConfiguracoes() {
  const { data } = await axios.get('/api/configuracoes');
  return data;
}

export async function updateConfiguracoes(payload: Record<string, any>) {
  const { data } = await axios.put('/api/configuracoes', payload);
  return data;
}

export async function getAparencia() {
  const { data } = await axios.get('/api/configuracoes/aparencia');
  return data;
}

export async function getNomeSistema() {
  const { data } = await axios.get('/api/configuracoes/nome-sistema');
  return data;
}

/** Flags voltadas ao cliente (qualquer usuário autenticado). */
export async function getConfiguracoesCliente() {
  const { data } = await axios.get('/api/configuracoes/cliente');
  return data as ConfiguracoesCliente;
}

/** Parâmetros públicos (telas abertas, ex.: redefinir senha). */
export async function getConfiguracoesPublico() {
  const { data } = await axios.get('/api/configuracoes/publico');
  return data as { portal_senha_tamanho_minimo: number };
}
